import { CustomCellRendererProps } from "ag-grid-react";
import { DECIMAL_2, INTEGER } from "presentation/utils/numberUtil";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { GeneralProposalConstant } from "./GeneralProposalConstant";

const GENERAL_PROPOSAL_CONSTANT = GeneralProposalConstant.Table;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_GENERAL_PROPOSAL_TARIFF_ITEM_TIER_COL_DEF: any[] = [
    // {
    //     headerName: GENERAL_PROPOSAL_CONSTANT.TIER_NO,
    //     field: 'tierNo',
    //     enableRowGroup: false,
    //     enablePivot: true,
    //     enableValue: false,
    //     rowGroup: false,
    //     // pinned: "left",
    //     checkboxSelection: true,
    //     headerCheckboxSelection: true,
    //     filter: true,
    //     width: 150,
    // },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.CYCLE,
        field: 'cycle',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        filter: true,
        width: 150,
        dataType: INTEGER,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.FOR_EVERY,
        field: 'forevery',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 140,
        dataType: INTEGER,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.UOM,
        field: 'uom',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 100,
    },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.RATE,
        field: 'rate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 100,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.MINIMUM,
        field: 'minimum',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 180,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.SURCHARGE,
        field: 'surcharge',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 150,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.SURCHARGE_TYPE,
        field: 'surchargeType',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 200,
    },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.ADDITIONAL_UOM,
        field: 'additionalUom',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 200,
    },
    {
        headerName: GENERAL_PROPOSAL_CONSTANT.ADDITIONAL_RATE,
        field: 'additionalRate',
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        filter: true,
        width: 200,
        dataType: DECIMAL_2,
        cellStyle: { textAlign: 'right' },
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}
